import { Injectable } from '@angular/core';
import { Action } from '../../models/action.interface';
import { ACTION_GROUP_CODES } from '../../enums/action-group-codes.enum';
import { APPLICATION_ACTIONS } from '../../enums/application-actions.enum';
import { APPLICATION_STATUSES } from '../../enums/application-statuses.enum';
import { PROGRAM_TYPES } from '../../enums/program-types.enum';

@Injectable({ providedIn: 'root' })
export class ApplicationActionMenuService {
	static isDownloadLetterOfCreditActionAvailable(
		applicationStatusCode: number,
		programTypeId: number
	): boolean {
		return (
			programTypeId === PROGRAM_TYPES.directBill &&
			(applicationStatusCode === APPLICATION_STATUSES.locIssued ||
				applicationStatusCode === APPLICATION_STATUSES.paymentReview ||
				applicationStatusCode ===
					APPLICATION_STATUSES.paymentProcessingIncomplete)
		);
	}

	static isActionAllowed(
		actions: Array<Action>,
		action: APPLICATION_ACTIONS
	): boolean {
		return !!actions?.find((act) => act.code === action);
	}

	static filterApplicationActions(
		actions: Array<Action>,
		actionGroup: ACTION_GROUP_CODES
	): Array<Action> {
		return actions.filter((action) => action.groupCode === actionGroup);
	}
}
